import SectionHeading from '@/components/base/SectionHeading';
import { testimonials } from '@/mocks/site';

export default function TestimonialSection() {
  return (
    <section className="border-t border-background-200 bg-background-100 paper-grain">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="读者反馈"
          title="读者的用法，往往比我们想象的更具体"
          desc="有人用来准备面试提问，有人用来判断补偿方案。以下是来自读者的部分反馈。"
        />

        <div className="grid gap-5 md:grid-cols-2">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800 md:text-base">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block font-label text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block font-label text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}